import * as Style from './Style.js';

export default function Occupation(options) {
	return <Style.EllipsisText title={options?.occupation}>{options?.occupation}</Style.EllipsisText>

}
